import { Component, OnInit, Input, Output } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from "@angular/forms";
import {
  FieldWrapper,
  KreFormFieldConfig,
  KreTableFieldConfig,
  clone,
} from "@kre-form/core";

@Component({
  selector: "kreform-ds_field-label",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
})
export class KreFormDSFieldLabel implements OnInit {
  formField: any = {
    key: "",
    type: "html",
    templateOptions: {
      label: "",
      description: "",
      parameterid: "",
      treeid: "",
      controlid: "",
      maxLength: 50,
      minLength: 0,
      max: 0,
      min: 0,
      precision: 0,
      placeholder: "",
      required: false,
      tips: "",
      pattern: "",
    },
    origin: {
      refdatasourcetype: "",
      datatype: "",
    },
  };
  @Input() set field(value: KreFormFieldConfig) {
    this.formField = { ...this.formField, ...value };
  }

  constructor() {}

  ngOnInit() {}

  submitForm() {}

  checkSave() {
    return true;
  }
}
